import { Divider, Stack, Typography } from '@mui/material'
import { i18WithParams as t } from '@shared/locales'
import { ReceiptAdminDto, ReceiptClientDto } from 'service-api/src/types'

export const OffersSection = ({ receipt }: { receipt: ReceiptClientDto | ReceiptAdminDto }) => (
  <>
    <Stack spacing={2}>
      <Divider sx={{ ml: -1, mr: -1 }} />
      {receipt.invoices?.map((invoice, invoiceIndex) => (
        <Stack key={invoiceIndex}>
          <Stack direction="row" justifyContent="space-between" mb={2}>
            <Stack>
              <Typography variant="h6">{invoice.displayName}</Typography>
              {invoice.pets && <Typography variant="caption">{invoice.pets.join(', ')}</Typography>}
            </Stack>
            <Typography variant="h6">{invoice.subtotal}</Typography>
          </Stack>
          {invoice.items?.map((item, itemIndex) => (
            <Stack key={itemIndex} direction="row" justifyContent="space-between" ml={1} mb={1}>
              <Typography variant="body1" flex={1.5}>
                {item.title + (item.pets ? ` (${item.pets.join(', ')})` : '')}
              </Typography>
              {item.price && item.quantity && (
                <Typography variant="body1" sx={{ flex: 1 }}>{`${item.price} x ${item.quantity}`}</Typography>
              )}
              <Typography variant="body1" sx={{ flex: 1, textAlign: 'right' }}>
                {item.subtotal}
              </Typography>
            </Stack>
          ))}
        </Stack>
      ))}
      <Stack spacing={1}>
        {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          Object.entries(receipt.taxes).map(([percentage, amount], index) => (
            <Stack key={index} direction="row" justifyContent="space-between">
              <Typography variant="h6">{t('global.label.taxPercentage', { percentage })}</Typography>
              <Typography variant="h6">{amount}</Typography>
            </Stack>
          ))
        }
      </Stack>
    </Stack>
    <Divider sx={{ mt: 1, ml: -1, mr: -1 }} />
  </>
)
